import { ItemType, ArticleFilter } from './types'

export const filterOnArticle = (
  { type, article }: ArticleFilter = { type: ItemType.ARTICLE },
): boolean => {
  if (type !== ItemType.ARTICLE) return true
  return type === ItemType.ARTICLE && (article?.displayable ?? false)
}
